import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "@phosphor-icons/react";
import PublicThemeControl from "@/components/PublicThemeControl";
import BrandLockup from "@/components/BrandLockup";

export default function AuthActionShell({ eyebrow, title, description, children, showSignIn = true, brandTo = "/login" }) {
  return (
    <div className="auth-action-page">
      <header className="auth-action-header">
        <Link to={brandTo} className="auth-action-brand" aria-label="Back to Callsect">
          <BrandLockup className="brand-lockup--legal" />
        </Link>
        <div className="auth-action-header__tools">
          <PublicThemeControl compact />
          {showSignIn && (
            <Link to="/login" className="auth-action-back">
              <ArrowLeft size={15} weight="bold" />
              Sign in
            </Link>
          )}
        </div>
      </header>

      <main className="auth-action-shell">
        <section className="auth-action-card">
          <span className="auth-action-card__accent" aria-hidden="true" />
          <div className="auth-action-card__mark" aria-hidden="true">
            <ShieldCheck size={23} weight="duotone" />
          </div>
          <div className="brand-eyebrow">{eyebrow}</div>
          <h1>{title}</h1>
          {description && <p className="auth-action-description">{description}</p>}
          <div className="segmented-divider" />
          <div className="auth-action-card__body">{children}</div>
        </section>

        <footer className="auth-action-footer">
          <span>Private beta</span>
          <nav aria-label="Legal information">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Beta Terms</Link>
            <Link to="/data-handling">Data handling</Link>
          </nav>
        </footer>
      </main>
    </div>
  );
}

export const authInputClass = "auth-action-input";
export const authButtonClass = "auth-action-primary-button";
